export const NOTIFICATION_CHANNELS = {
  EMAIL: "email",
  SMS: "sms",
  PUSH: "push",
};

export const NOTIFICATION_CHANNELS_LABELS = {
  [NOTIFICATION_CHANNELS.EMAIL]: "Email",
  [NOTIFICATION_CHANNELS.SMS]: "SMS",
  [NOTIFICATION_CHANNELS.PUSH]: "Push",
};
